import { Box, Tooltip } from '@mui/material';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { postToAdmin, MSG } from '@/lib/adminAnnotation';

/**
 * Tiny inline indicator rendered after paragraph config text in admin annotation mode.
 * Click sends the paragraph code back to the admin portal for grid selection.
 * Only ever mounted when annotationModeAtom is true — zero cost for normal patients.
 */
export function PpAnnotationPin({ code }: Readonly<{ code: string }>) {
  return (
    <Tooltip title={code} placement="top" arrow>
      <Box
        component="span"
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          e.preventDefault();
          postToAdmin({ type: MSG.PARAGRAPH_SELECTED, code });
        }}
        sx={{
          fontSize: '0.85em',
          verticalAlign: 'super',
          cursor: 'pointer',
          color: 'primary.dark',
          opacity: 0.7,
          ml: '2px',
          display: 'inline-block',
          userSelect: 'none',
          lineHeight: 1,
          '&:hover': { opacity: 1 },
        }}
      >
        <EditNoteIcon fontSize="inherit" sx={{ display: 'block' }} />
      </Box>
    </Tooltip>
  );
}
